import React, { useRef, useEffect } from 'react';
import { AuthAPI } from '../../axios';

const AnnotatedImage = ({ imageUrl, annotations }) => {
  const canvasRef = useRef(null);
  const fixedWidth = 400;
  const fixedHeight = 250;

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await AuthAPI.getImage(imageUrl);
        console.log("Image Response: ", response); // Should contain the `image` field
  
        const image = new Image();
        image.src = response.image; // Use response.image for the Base64 data
  
        image.onload = () => {
          const canvas = canvasRef.current;
          const context = canvas.getContext('2d');
          const imageAspectRatio = image.width / image.height;
          const canvasAspectRatio = fixedWidth / fixedHeight;
          let drawWidth, drawHeight;
  
          if (imageAspectRatio > canvasAspectRatio) {
            drawWidth = fixedWidth;
            drawHeight = fixedWidth / imageAspectRatio;
          } else {
            drawHeight = fixedHeight;
            drawWidth = fixedHeight * imageAspectRatio;
          }
  
          const scaleX = drawWidth / image.width;
          const scaleY = drawHeight / image.height;
  
          canvas.width = fixedWidth;
          canvas.height = fixedHeight;
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0, drawWidth, drawHeight);
  
          annotations.forEach(annotation => {
            const { x1, y1, x2, y2 } = annotation;
            const scaledX1 = x1 * scaleX;
            const scaledY1 = y1 * scaleY;
            const scaledX2 = x2 * scaleX;
            const scaledY2 = y2 * scaleY;
            const x = Math.min(scaledX1, scaledX2);
            const y = Math.min(scaledY1, scaledY2);
            const width = Math.abs(scaledX2 - scaledX1);
            const height = Math.abs(scaledY2 - scaledY1);
  
            context.strokeStyle = 'red';
            context.lineWidth = 1;
            context.strokeRect(x, y, width, height);
          });
        };
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };
  
    fetchImage();
  }, [imageUrl, annotations]);
  

  return (
    <canvas
      ref={canvasRef}
      style={{ width: `${fixedWidth}px`, height: `${fixedHeight}px`, objectFit: 'contain' }}
    />
  );
};

export default AnnotatedImage;
